import RegularText from '@/components/RegularText';
import { Box } from '@shopify/polaris';
import { useTranslation } from 'react-i18next';
import AppModal from '../../../../components/AppModal/AppModal';

type TModalUpgradePlan = {
  isShowModal: boolean;
  onHide: () => void;
  checkPlanAddMoreLocations: boolean;
};

const ModalUpgradePlan = ({ isShowModal, onHide, checkPlanAddMoreLocations }: TModalUpgradePlan) => {
  const { t } = useTranslation('locations');

  return (
    <AppModal
      title={t('modalUpgradePlan.close')}
      open={isShowModal}
      onCancel={onHide}
      submitText={t('modalUpgradePlan.upgradeNow')}
      cancelText={t('modalUpgradePlan.close')}
      onSubmit={() => console.log('upgrade plan')}
    >
      <Box padding="400">
        {checkPlanAddMoreLocations ? (
          <RegularText>{t('modalUpgradePlan.contactSupport')}.</RegularText>
        ) : (
          <RegularText>{t('modalUpgradePlan.upgradeToAdd')}.</RegularText>
        )}
      </Box>
    </AppModal>
  );
};

export default ModalUpgradePlan;
